// extracted by mini-css-extract-plugin
export default {"marginBtm":"HealthCheckContent_marginBtm__ge6V0","deskInfoHeader":"HealthCheckContent_deskInfoHeader__NkmeQ","deskInfoClass":"HealthCheckContent_deskInfoClass__r3muT"};